import React, { useState } from 'react';
import { createPath, ROUTE } from 'utils/Routing';
import { Redirect, Route } from 'react-router-dom';
import useFetch from 'hooks/useFetch';
import Loading from 'components/Loading/Loading';
import Card from 'components/Card/Card';
import Pagination from 'components/Pagination/Pagination';
import Modal from 'components/Modal/Modal';
import './GameListPage.css';

const GameListPage = () => {
  const [isOpen, setIsOpen] = useState(true);

  const [indexOfFirstPost, setIndexOfFirstPost] = useState(0);
  const contentPerPage: number = 6;

  const { response: totalPosts, error: totalPostsError, isLoading: totalPostIsLoading } = useFetch({
    method: 'get',
    url: '/games/count/',
  });

  const { response: fetchedPosts, error: fetchedPostsError, isLoading: fetchedPostsIsLoading } = useFetch({
    method: 'get',
    url: `/games?_sort=name:asc&_limit=${contentPerPage}&_start=${indexOfFirstPost}`,
  });

  if (fetchedPostsIsLoading || totalPostIsLoading) {
    return <Loading />;
  }

  if (totalPostsError.error || fetchedPostsError.error) {
    return (
      <Modal
        open={isOpen}
        info={fetchedPostsError.body || totalPostsError.body}
        type='error'
        onClose={() => setIsOpen(false)}
      />
    );
  }

  if (!fetchedPosts.length) {
    return (
      <Route>
        <Redirect to={createPath({ path: ROUTE.HOME })} />
      </Route>
    );
  }

  return (
    <>
      <div className='game-list__wrapper'>
        {fetchedPosts.map((game: any) => {
          return <Card id={game.id} image={game.cover_art?.formats.small.url} title={game.name} key={game.id} />;
        })}
      </div>
      <Pagination totalPosts={totalPosts} setIndexOfFirstPost={setIndexOfFirstPost} contentPerPage={contentPerPage} />
    </>
  );
};

export default React.memo(GameListPage);
